import { handleResponse, authHeader } from '../_helpers';
import { config } from "../../common/constant";
import { getPaymentEndpoint } from '../../common';
import { captureApiError } from '../../common';

export const PayNow = {
    getTransactionNumber,
    getPaynowQRCode,
    checkTransactionStatus,
    enquiryTransactionStatus,
    getNetsQRCode,
    enquiryNetsQrTransactionStatus,
};

async function getNetsQRCode(payload) {
  const version = getPaymentEndpoint();
  const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(payload),
  };

  const url = config.BASE_URL_DOMAIN + `/payment-${version}/api/Donation/getNetsQrCode`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      if (
       (result.data !== null &&
        result.data !== undefined &&
        result.data.status === 1)
        || result.data.status === -1
      ) {
        return result.data;
      } else {
       // captureApiError(result)
        return false;
      }
    })
    .catch((error) => {
      captureApiError(error)
      return false;
    });
}

async function getTransactionNumber(payload) {
  const version = getPaymentEndpoint();
    const requestOptions = {
        cache:'reload',
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };

    const url = config.BASE_URL_DOMAIN + `/payment-${version}/api/Donation/initiatePayment`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
              captureApiError(result)
                return false
            }
        }).catch(error => {
          captureApiError(error)
            return false;
        });
}

async function getPaynowQRCode(payload) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(payload),
    };

    const url = config.PAYNOW_QR_URL + "/api/Donation/getPaynowQrCode";

    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((result) => {
        if (
          result.data !== null &&
          result.data !== undefined &&
          result.data.status === 1
        ) {
          return result.data;
        } else {
          captureApiError(result)
          return false;
        }
      })
      .catch((error) => {
        captureApiError(error)
        return false;
      });
}

async function checkTransactionStatus (payload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
      method: "POST",
      headers: authHeader()
    }

    const url = config.BASE_URL_DOMAIN + `/payment-${version}/api/Donation/checkTransactionStatus?transactionNumber=${payload}`

    return fetch(url, requestOptions)
      .then(handleResponse)
      .then(response => {
        if(response !== null && response !== undefined){
          return response.data
        } else {
          return false
        }
      }).catch( error => {
        captureApiError(error)
        return false
      })

}

// Enquiry Transaction Status for Paynow
async function enquiryTransactionStatus(payload) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(payload)
    }

    const url = config.PAYNOW_QR_URL + `/api/Donation/paynowTransactionEnquiry`
    // https://test-payment.givepls.com/api/Donation/paynowTransactionEnquiry

    return fetch(url, requestOptions)
      .then(handleResponse)
      .then(response => {
        if(response !== null && response !== undefined){
          return response.data
        } else {
          return false
        }
      }).catch( error => {
        captureApiError(error)
        return false
      })
}


// Enquiry Transaction Status for NetsQr
async function enquiryNetsQrTransactionStatus(payload) {
  const version = getPaymentEndpoint();
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(payload)
  }

  const url = config.BASE_URL_DOMAIN + `/payment-${version}/api/Donation/netsQrTransactionEnquiry`
  // https://test-payment.givepls.com/api/Donation/paynowTransactionEnquiry

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(response => {
      if(response !== null && response !== undefined){
        return response.data
      } else {
        return false
      }
    }).catch( error => {
      captureApiError(error)
      return false
    })
}